import React from 'react';

const NotFound = () => (
  <div className="container mx-auto px-4 py-8 text-center">
    <h1 className="text-3xl font-bold mb-4">Page Not Found</h1>
    <p>The page you're looking for doesn't exist.</p>
  </div>
);

export default NotFound;
